export default __webpack_public_path__ + "static/image-23-ea60533396a588b2da17cae8da49315b.jpg";